import { render } from "./Account.vue?vue&type=template&id=d8a6c3ee"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Customers/Account.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d8a6c3ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d8a6c3ee', __exports__)) {
    api.reload('d8a6c3ee', __exports__)
  }
  
  module.hot.accept("./Account.vue?vue&type=template&id=d8a6c3ee", () => {
    api.rerender('d8a6c3ee', render)
  })

}


export default __exports__